import request from '@/utils/request'
import store from '../store'
import axios from 'axios'

// 获取个人资料
export function getUserInfoApi (data) {
  return request({
    url: '/ordering_system_mobile/userinfo/userInformation',
    method: 'post',
    data: {
      userId: store.state.user.userId,
      // conferenceId: store.state.user.conferenceId
      ...data
    }
  })
}

// 设置个人资料
export function setUserInfoApi (data) {
  return request({
    url: '/ordering_system_mobile/userinfo/updateuserInformation',
    method: 'post',
    data: {
      userId: store.state.user.userId,
      ...data
    }
  })
}

// 添加或取消个人收藏
export function saveUserCollect (data) {
  return request({
    url: '/ordering_system_mobile/collect/saveUserCollect',
    method: 'post',
    data: {
      userId: store.state.user.userId,
      ...data
    }
  })
}

// 收藏夹列表
export function getCollectList (data) {
  return request({
    url: '/ordering_system_mobile/collect/getCollectList',
    method: 'post',
    data: {
      userId: store.state.user.userId,
      num: 10,
      ...data
    }
  })
}

// 我的客户
export function getMyClient (data) {
  return request({
    url: '/ordering_system_mobile/conferenceinvite/getMyClient',
    method: 'post',
    data: {
      userId: store.state.user.userId,
      // conferenceId: store.state.user.conferenceId,
      num: 10,
      ...data
    }
  })
}

// 增加日志信息
export function addLogInfo (data) {
  return axios({
    url: process.env.BASE_URL + '/ordering_system_mobile/conferenceuserlog/addInfo',
    headers: {
      'Content-Type': 'application/json'
    },
    method: 'post',
    data: {
      data: JSON.stringify({
        logUserId: store.state.user.userId,
        logType: 1,
        logUserDevice: navigator.userAgent,
        logContent: JSON.stringify({
          ...data
        })
      })
    }
  })
}



// WEBPACK FOOTER //
// ./src/api/user.js